import { apiSlice } from "app/api/apiSlice";

export const BankingApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getBankingLeads: builder.query({
      query: (pagination) =>
        `/api/v1/banking/leads?page=${pagination.page}&per_page=15`,
    }),
    getBankingLeadsById: builder.query({
      query: (id) => `/api/v1/crm/leads/${id}`,
    }),
    addNewBankingLead: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/banking/leads",
        method: "POST",
        body: payload,
      }),
    }),
    updateBankingLeadById: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/banking/leads/${id}`,
        method: `PUT`,
        body: payload,
      }),
    }),
    getBankingApplications: builder.query({
      query: (pagination) =>
        `/api/v1/banking/applications?page=${pagination.page}&per_page=10`,
    }),
    getBankingApplicationsById: builder.query({
      query: (id) => `/api/v1/banking/application/${id}`,
    }),
    getoccupationDropdown: builder.query({
      query: (id) => `/api/v1/master/dropdowns`,
    }),
    updateConsent: builder.mutation({
      query: ({ id, payload }) => ({
        url: "/api/v1/banking/update-consent",
        method: "POST",
        body: payload,
      }),
    }),
    addBankingApplication: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/banking/application",
        method: "POST",
        body: payload,
      }),
    }),
    getBankingApplicationDetailsId: builder.query({
      query: (id) => `/api/v1/banking/application-data/${id}`,
    }),
    createApplicant: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/banking/applicants",
        method: "POST",
        body: payload,
      }),
    }),
    getCrmLeads: builder.query({
      query: ({
         page, per_page,
        // pagination,
        searchKey,
        activeBusinessKey,
        stateId,
        districtId,
        statusName,
        SelectedFle,
        productName,
        bank_name
      }) => {
        const params = new URLSearchParams();
        if (page) params.append("page", page);
        params.append("per_page", per_page || 10);
        if (searchKey) params.append("q", searchKey);
        if (activeBusinessKey === "B2C" || activeBusinessKey === "B2B") {
          params.append("type", activeBusinessKey);
        }
        if (stateId) params.append("state_code", stateId);
        if (districtId) params.append("district_code", districtId);
        if (statusName) params.append("current_status", statusName);
        if (SelectedFle) params.append("assigned_emp_id", SelectedFle);
        if (bank_name) params.append("bank_name", bank_name);
        if (productName) params.append("product_name", productName);
        const queryString = params.toString();
        return `/api/v1/crm/banking/leads?${queryString}`;
      },
      keepUnusedDataFor: 0,
    }),
    getCrmLeadsById: builder.query({
      query: (id) => `/api/v1/crm/leads/${id}`,
    }),
    addCrmLead: builder.mutation({
      query: (payload) => ({
        url: "/api/v1/crm/leads",
        method: "POST",
        body: payload,
      }),
    }),
    updateCrmLeadById: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/crm/leads/${id}`,
        method: `PATCH`,
        body: payload,
      }),
    }),
    updateLeadApplication: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/crm/leads/${id}/convert`,
        method: "POST",
        body: payload,
      }),
    }),
    getBankingCrmDocuments: builder.query({
      query: (id) => `/api/v1/banking/documents/${id}`,
    }),
    // getBankingLoanApplication: builder.query({
    //   query: ({ pagination, activeBusinessKey, searchKey }) =>
    //     `/api/v1/banking/application-data?page=${pagination.page}&per_page=10&product_type=${activeBusinessKey}&query=${searchKey}`,

    // }),
    getBankingLoanApplication: builder.query({
      query: ({
        pagination = { page: 1, per_page: 10 },
        searchKey,
        activeBusinessKey,
        stateId,
        districtId,
        statusName,
        SelectedFle,
        productName,
        bank_name
      }) => {
        const params = new URLSearchParams();

        params.append("page", pagination.page);
        params.append("per_page", pagination.per_page || 10);

        if (searchKey) {
          params.append("query", searchKey);
        }
        if (activeBusinessKey === "B2C" || activeBusinessKey === "B2B") {
          params.append("product_type", activeBusinessKey);
        }
        if (stateId !== null && stateId !== undefined && stateId !== "null") {
          params.append("state_code", stateId);
        }

        if (
          districtId !== null &&
          districtId !== undefined &&
          districtId !== "null"
        ) {
          params.append("district_code", districtId);
        }
        if (statusName) {
          params.append("application_status", statusName);
        }
        if (SelectedFle) {
          params.append("lead_created_by", SelectedFle);
        }
        if (productName) {
          params.append("product_name", productName);
        }
         if (bank_name) {
          params.append("bank_name", bank_name);
        }

        const queryString = params.toString();
        return `/api/v1/banking/application-data?${queryString}`;
      },
      keepUnusedDataFor: 0,
    }),

    getBankingLeadsList: builder.query({
      query: () => `api/v1/crm/banking/leads`,
    }),
    getPmfmeData: builder.query({
      query: ({ searchKey }) =>
        `/survey/loan-application/loan-users?search=${searchKey}`,
    }),
    getPmfmeDatabyId: builder.query({
      query: (id) => `/survey/loan-application/loan-users/${id}`,
    }),
    PmfmeAprrovalbyId: builder.mutation({
      query: ({ ApplicantId, approval }) => ({
        url: `/survey/loan-application/action/${ApplicantId}`,
        method: `PATCH`,
        body: approval,
      }),
    }),

    updateApplicantBanking: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/api/v1/banking/applicants/${id}`,
        method: `PUT`,
        body: payload,
      }),
    }),
    updatePmfePersonalById: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/loan-application/personal-detail/${id}`,
        method: `PUT`,
        body: payload,
      }),
    }),
    updatePmfeBusinessById: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/loan-application/pmfme-form/business-detail/${id}`,
        method: `PUT`,
        body: payload,
      }),
    }),
    updatePmfmeDocumentById: builder.mutation({
      query: ({ id, payload }) => ({
        url: `/loan-application/document-detail/upload-document`,
        method: `POST`,
        body: payload,
      }),
    }),
    getAnalyticsApiData: builder.query({
      query: (payload) => ({
        url: `/mis/api/v1/analytics`,
        method: "POST",
        body: payload,
      }),
    }),

    getFeedbackFormById: builder.query({
      query: (pagination) =>
        `/api/v1/banking/feedback?page=${pagination.page}&per_page=10`,
    }),
    updateFeedbackData: builder.mutation({
      query: ({ updatedId, payload }) => ({
        url: `/api/v1/banking/feedback/${updatedId}`,
        method: "PATCH",
        body: payload,
      }),
    }),

    uploadTakeActionsBanking: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/api/v1/banking/update-application-status/${id}`,
        method: "PATCH",
        body: formData,
      }),
    }),
    getCommissionApplicationListbyId: builder.query({
      query: (posp_id) => `/api/v1/banking/applications/posp/${posp_id}`,
    }),
    createCommission: builder.mutation({
      query: (payload) => ({
        url: `/api/v1/banking/create-commission`,
        method: `POST`,
        body: payload,
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    //    getCrmLeadsIncludes: builder.query({
    //     query: ({pagination,searchKey,activeBusinessKey,stateId,districtId,statusName}) => `/api/v1/crm/banking/leads?page=${pagination.page}&per_page=10&q=${searchKey}${activeBusinessKey==='B2C' ? "&type=B2C": activeBusinessKey==='B2B'?'&type=B2B':""}`
    // }),
    getCrmLeadsIncludes: builder.query({
      query: ({
        pagination = { page: 1, per_page: 10 },
        searchKey,
        activeBusinessKey,
        stateId,
        districtId,
        statusName,
        SelectedFle,
        productName,
      }) => {
        const params = new URLSearchParams();
        if (pagination.page) params.append("page", pagination.page);
        params.append("per_page", pagination.per_page || 10);
        if (searchKey) params.append("q", searchKey);
        if (activeBusinessKey === "B2C" || activeBusinessKey === "B2B") {
          params.append("type", activeBusinessKey);
        }
        if (stateId) params.append("state_code", stateId);
        if (districtId) params.append("district_code", districtId);
        if (statusName) params.append("application_status", statusName);
        if (SelectedFle) params.append("lead_created_by", SelectedFle);
        if (productName) params.append("product_name", productName);
        params.append("status_includes", "Application Created");
        const queryString = params.toString();
        return `/api/v1/crm/banking/leads?${queryString}`;
      },
      keepUnusedDataFor: 0,
    }),
    getPospList: builder.query({
      query: ({ districtId, searchKey }) => `/api/v1/onboarding/employees/POSP`,
    }),
  }),
});

export const {
  useGetBankingLeadsQuery,
  useGetBankingLeadsByIdQuery,
  useAddNewBankingLeadMutation,
  useUpdateBankingLeadByIdMutation,
  useGetBankingApplicationsQuery,
  useGetBankingApplicationsByIdQuery,
  useGetoccupationDropdownQuery,
  useUpdateConsentMutation,
  useAddBankingApplicationMutation,
  useGetBankingApplicationDetailsIdQuery,
  useCreateApplicantMutation,
  useGetCrmLeadsQuery,
  useGetCrmLeadsByIdQuery,
  useAddCrmLeadMutation,
  useUpdateCrmLeadByIdMutation,
  useUpdateLeadApplicationMutation,
  useGetBankingCrmDocumentsQuery,
  useGetBankingLoanApplicationQuery,
  useGetBankingLeadsListQuery,
  useGetPmfmeDataQuery,
  useGetPmfmeDatabyIdQuery,
  usePmfmeAprrovalbyIdMutation,
  useUpdateApplicantBankingMutation,
  useUpdatePmfePersonalByIdMutation,
  useUpdatePmfeBusinessByIdMutation,
  useUpdatePmfmeDocumentByIdMutation,
  useGetAnalyticsApiDataQuery,
  useGetFeedbackFormByIdQuery,
  useUpdateFeedbackDataMutation,
  useUploadTakeActionsBankingMutation,
  useGetCommissionApplicationListbyIdQuery,
  useCreateCommissionMutation,
  useGetCrmLeadsIncludesQuery,
  useGetPospListQuery,
} = BankingApiSlice;
